module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a6a10707fe9a131390ccb9d9d7449734.png";